import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { User, LogOut, Heart, MessageCircle, LayoutDashboard, Building2 } from "lucide-react";

export default function UserMenu() {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <div className="flex items-center gap-2" data-testid="nav-auth-guest">
        <Link to="/login" data-testid="nav-login" className="text-sm text-muted-foreground hover:text-forest px-3 py-2">
          Sign in
        </Link>
        <Link to="/signup" data-testid="nav-signup" className="inline-flex items-center rounded-full bg-forest hover:bg-forest-hover text-white px-4 py-2 text-sm font-medium">
          Sign up
        </Link>
      </div>
    );
  }

  const initials = (user.name || user.email).trim().split(/\s+/).map((s) => s[0]).slice(0, 2).join("").toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="nav-user-menu" className="w-9 h-9 rounded-full bg-forest text-gold font-heading font-bold text-sm flex items-center justify-center hover:bg-forest-hover transition-colors">
          {initials}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="font-medium text-forest">{user.name || "Account"}</div>
          <div className="text-[11px] text-muted-foreground font-normal">{user.email}</div>
          <div className="text-[10px] uppercase tracking-widest text-gold mt-1">{user.role}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.role === "admin" && (
          <DropdownMenuItem asChild><Link to="/admin" data-testid="user-menu-admin"><LayoutDashboard className="w-4 h-4 mr-2" /> Admin dashboard</Link></DropdownMenuItem>
        )}
        {user.role === "builder" && (
          <DropdownMenuItem asChild><Link to="/builder" data-testid="user-menu-builder"><Building2 className="w-4 h-4 mr-2" /> Builder portal</Link></DropdownMenuItem>
        )}
        {user.role === "buyer" && (
          <>
            <DropdownMenuItem asChild><Link to="/me" data-testid="user-menu-favorites"><Heart className="w-4 h-4 mr-2" /> Favorites & inquiries</Link></DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} data-testid="user-menu-signout" className="text-destructive"><LogOut className="w-4 h-4 mr-2" /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
